import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const env = createEnv({
  clientPrefix: 'VITE_',
  client: {
    VITE_PUBLIC_NETWORKS_MODE: z
      .enum(['testnet', 'mainnet'])
      .default('testnet'),
    VITE_PUBLIC_SOLANA_RPC: z.string().optional(),
    VITE_API_URL: z.string().optional(),
    VITE_SENTRY_AUTH_TOKEN: z.string().optional(),
    VITE_INTERCOM_APP_ID: z.string().optional(),
    VITE_MODE: z
      .enum(['development', 'production'])
      .optional()
      .default('development'),
  },
  runtimeEnv: import.meta.env,
});
